import {
  ConfigurationPanelStructureItemEnum, ElementPartTypeEnum, FieldConfig, TemplateParentTypeEnum, TemplateStructureEnum, WidgetTypeConfig,
} from '@/types';
// V3
// eslint-disable-next-line import/no-cycle
import emailSeparatorFieldsConfig from '@/components/template-builder/config/templates/email/widgets/widget-separator-fields-config';
// eslint-disable-next-line import/no-cycle
import displaySeparatorFieldsConfig from '@/components/template-builder/config/templates/display/widgets/widget-separator-fields-config';
// V4
// eslint-disable-next-line import/no-cycle
import emailSeparatorFieldsConfigV4 from '@/components/template-builder/config/templates/email-v4/widgets/widget-separator-fields-config';
// eslint-disable-next-line import/no-cycle
import displaySeparatorFieldsConfigV4 from '@/components/template-builder/config/templates/display-v4/widgets/widget-separator-fields-config';
// eslint-disable-next-line import/no-cycle
import getWidgetCommonStylesGroup from '@/components/template-builder/config/fields/widget-common-styles-config';
// eslint-disable-next-line import/no-cycle
import { isEmailTemplate } from '../../utils/helpers';

const getWidgetSeparatorConfig = (templateType: TemplateParentTypeEnum, isV4 = false): WidgetTypeConfig => {
  let fieldItems: Array<FieldConfig> = [];
  switch (templateType) {
    case TemplateParentTypeEnum.POPUP:
    case TemplateParentTypeEnum.EMBED:
      fieldItems = isV4 ? displaySeparatorFieldsConfigV4 : displaySeparatorFieldsConfig;
      break;
    default:
      fieldItems = isV4 ? emailSeparatorFieldsConfigV4 : emailSeparatorFieldsConfig;
  }

  const paddingSelector = isEmailTemplate(templateType) ? '{SELECTOR} > tbody > tr > th' : '{SELECTOR}';

  return {
    tabPanel: {
      label: 'templateBuilder.widgetsHeaders.separator',
      items: [
        {
          type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
          tabItemType: TemplateStructureEnum.GROUP,
          label: 'templateBuilder.configs.widgetStyles',
          canSave: true,
          elementPartType: ElementPartTypeEnum.STYLES,
          tabPanel: {
            items: [
              {
                type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
                label: 'templateBuilder.configs.widgetBlockStyles',
                selector: 'body #spm_body #{ID}',
                items: fieldItems,
              },
              getWidgetCommonStylesGroup(paddingSelector),
            ],
          },
        },
      ],
    },
  };
};

export default getWidgetSeparatorConfig;
